import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: left;
  //position: relative;
  width: 100%;

  & > * {
    font-size: 16px;
    // font-family: Montserrat;
    font-weight: 500;
  }
`;

const TextDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  & > * {
    font-size: 16px;
    // font-family: Montserrat;
    font-weight: 500;
  }

  & > span {
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '-40px')};
    color: #636363;
  }
`;

const TextField = styled.input`
  box-sizing: border-box;
  padding: 14px 18px;
  width: 100%;

  background: ${({ readOnly }) => (readOnly ? '#f0f0f0' : '#ffffff')};
  color: ${({ readOnly }) => (readOnly ? '#8a8a8a' : 'inherit')};
  cursor: ${({ readOnly }) => (readOnly ? 'not-allowed' : 'text')};
  border: 1px solid ${({ error }) => (error ? '#d74748' : '#a2a2a2')};
  border-radius: 8px;
  outline: none;
  margin-top: 6px;
  // font-family: 'Inter';
  font-family:inherit;

  :focus {
    background: ${({ readOnly }) => (readOnly ? '#f0f0f0' : '#ffffff')};
  }

  &:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset !important;
    -webkit-text-fill-color: black !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

const InputTitle = styled.label`
    display: -webkit-inline-box;
  padding: 8px 0px;
  width: 100%;
  color: #292A2A;
  font-family:inherit;
    // font-family: 'Inter';
  margin-left:${(props) => (props?.showAi ? '8px' : '')};
`;

const ErrorMessage = styled.div`
  padding: 2px 10px;

  color: #d74748;
  // font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
`;

const Input = ({
  label,
  require,
  type,
  name,
  placeholder,
  value,
  onChange,
  customStyle,
  characterLimit,
  maxLength,
  limit,
  readOnly,
  error = '',
  TextDivStyle = {},
  marginLeft = '-40px',
  showAi = false,
  isExecutive = false
}) => {
  const [remainingCharacters, setRemainingCharacters] =
    useState(characterLimit);

  useEffect(() => {
    if (value) {
      setRemainingCharacters(characterLimit - value.length);
    }
  }, [value, characterLimit]);

  return (
    <Wrapper>
      {label && (
        <>
          <InputTitle showAi={showAi}>
            {label}
            {require && <span style={{ color: '#FC6758' ,float :isExecutive ?'none' :'left',marginLeft: '-8px' }}>&nbsp; *</span>}
          </InputTitle>
          <br />
        </>
      )}
      <TextDiv style={TextDivStyle} marginLeft={marginLeft}>
        <TextField
          type={type || 'text'}
          name={name || ''}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={customStyle}
          maxLength={maxLength}
          limit={limit}
          error={error}
          readOnly={readOnly}
        />
        {value && characterLimit ? (
          <span>{remainingCharacters}</span>
        ) : (
          <span>{limit}</span>
        )}
      </TextDiv>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Wrapper>
  );
};

export default Input;
